import RestbestandRow, { RestbestandRowApiModel } from './RestbestandRow';

export interface RestbestandResponseApiModel {
  liegengebliebene: RestbestandRowApiModel[];
  lagernde: RestbestandRowApiModel[];
  afnus: RestbestandRowApiModel[];
  bereinigung: RestbestandRowApiModel[];
}

export default class RestbestandResponse {
  constructor(
    public readonly liegengebliebene: RestbestandRow[],
    public readonly lagernde: RestbestandRow[],
    public readonly afnus: RestbestandRow[],
    public readonly bereinigung: RestbestandRow[]
  ) {}

  static fromJson(json: RestbestandResponseApiModel): RestbestandResponse {
    const map = (rows?: RestbestandRowApiModel[]) => (rows || []).map(RestbestandRow.fromJson);
    return new RestbestandResponse(
      map(json?.liegengebliebene),
      map(json?.lagernde),
      map(json?.afnus),
      map(json?.bereinigung)
    );
  }
}
